import { CarTaxiFront } from "lucide-react";

export const LogoMark = ({ size = 20 }) => (
    <span
        data-testid="logo-mark"
        className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-lg bg-amber-400 pb-1 text-night-950 shadow-[0_4px_18px_-4px_rgba(245,158,11,0.55)] transition-transform duration-300 group-hover:-rotate-6"
    >
        <CarTaxiFront size={size} strokeWidth={2.4} />
        <span className="absolute inset-x-1.5 bottom-1 h-[3px] rounded-full bg-[#3D7EAF]" />
    </span>
);

export const LogoLockup = ({ caption = "24/7 — DRUNEN" }) => (
    <span className="flex flex-col justify-center leading-none">
        <span className="font-display font-wide text-lg font-extrabold uppercase tracking-tight text-white">
            Taxi Drunnen
        </span>
        <span className="mt-1 font-mono text-[9px] font-bold tracking-[0.3em] text-amber-400/90">
            {caption}
        </span>
    </span>
);
